var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11 5.5V3a2 2 0 00-2-2H3a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2v-2.5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 6,
    y: 8,
    fill: "currentColor",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M15.656 5.343l2.95 2.95a1 1 0 010 1.414l-2.95 2.95"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiPjxnIG9wYWNpdHk9Ii43Ij48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMTEgNS41VjNhMiAyIDAgMCAwLTItMkgzYTIgMiAwIDAgMC0yIDJ2MTJhMiAyIDAgMCAwIDIgMmg2YTIgMiAwIDAgMCAyLTJ2LTIuNSIvPjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIyIiB4PSI2IiB5PSI4IiBmaWxsPSJjdXJyZW50Q29sb3IiIHJ4PSIxIi8+PHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZD0ibTE1LjY1NiA1LjM0MyAyLjk1IDIuOTVhMSAxIDAgMCAxIDAgMS40MTRsLTIuOTUgMi45NSIvPjwvZz48L3N2Zz4=";
export { SvgSignOut as ReactComponent };